import VueHtmlToPaper from 'vue-html-to-paper'
import Vue from 'vue'
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    '/print.css'
  ]
}
Vue.use(VueHtmlToPaper, options);
